import React, { useState, useEffect, useContext } from "react";
import {
	Box,
	Typography,
	Paper,
	Button,
	Select,
	MenuItem,
	FormControl,
	IconButton,
	getLuminance,
	lighten,
	darken,
	alpha,
} from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CustomCalendar from "../CustomCalendar/CustomCalendar";
import { IconArrowLeft } from "@tabler/icons-react";
import ConnectionsClient from "../../services/ConnectionsClient";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../contexts/CreatorContext";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { UserContext } from "../../contexts/UserContext";

function Schedule() {
	const { t } = useTranslation();
	const { state } = useLocation();
	const { selectedService, selectedOptions } = state;

	const navigate = useNavigate();
	const { basePath } = useParams();
	const [workersData] = useState(selectedService?.workers);
	const [selectedWorker, setSelectedWorker] = useState("");
	const [selectedDateTime, setSelectedDateTime] = useState(null);
	const [selectedTime, setSelectedTime] = useState(null);
	const [availableHours, setAvailableHours] = useState([]);

	const { creator, creatorWorkers } = useContext(CreatorContext);

	const handleWorkerSelect = (event) => {
		const worker =
			selectedService?.workers?.length > 0 &&
			selectedService.workers.find(
				(worker) => worker.id === event.target.value
			);
		setSelectedWorker(worker);
		setSelectedDateTime(null);
		setAvailableHours([]); // Reiniciar horas disponibles cuando se cambia de trabajador
	};

	useEffect(() => {
		const getWorkingHours = async () => {
			let workingHoursResponse = {};
			if (!creator.isCreator) {
				workingHoursResponse = await ConnectionsClient.get("/workingHours", {
					params: {
						workerId: selectedWorker.id,
						//appId: "58931d28-295b-4ba7-9f5a-4b6d0627d459",
					},
				});
			} else {
				workingHoursResponse.data = [
					...creatorWorkers.find((worker) => worker.id === selectedWorker.id)
						.workingHours,
				];
			}

			return workingHoursResponse.data;
		};
		const getWorkerHolidays = async () => {
			let workerHolidaysResponse = {};
			if (!creator.isCreator) {
				workerHolidaysResponse = await ConnectionsClient.get(
					"/workerHolidays",
					{
						params: {
							workerId: selectedWorker.id,
							//appId: "58931d28-295b-4ba7-9f5a-4b6d0627d459",
						},
					}
				);
			} else {
				workerHolidaysResponse.data = [
					...creatorWorkers.find((worker) => worker.id === selectedWorker.id)
						.workerHolidays,
				];
			}

			return workerHolidaysResponse.data;
		};
		const getWorkerAppointments = async () => {
			let workerAppointmentsResponse = {};
			if (!creator.isCreator) {
				workerAppointmentsResponse = await ConnectionsClient.get(
					"/workerAppointments",
					{
						params: {
							workerId: selectedWorker.id,
							//appId: "58931d28-295b-4ba7-9f5a-4b6d0627d459",
						},
					}
				);
			} else {
				let appointments = await AsyncStorage.getItem("appointments");
				workerAppointmentsResponse.data = appointments
					? JSON.parse(appointments)
					: [];
			}
			return workerAppointmentsResponse.data;
		};

		const getWorkerData = async () => {
			const workingHours = await getWorkingHours();
			const workerHolidays = await getWorkerHolidays();
			const workerAppointments = await getWorkerAppointments();

			let updatedWorker = { ...selectedWorker };
			updatedWorker = {
				...updatedWorker,
				workingHours: workingHours,
				workerHolidays: workerHolidays,
				appointments: workerAppointments,
			};

			setSelectedWorker(updatedWorker);
			getData(new Date(), selectedService, selectedOptions, updatedWorker);
		};

		if (
			selectedWorker &&
			(selectedWorker.workingHours === undefined ||
				(creator.isCreator && selectedWorker.appointments === undefined))
		) {
			getWorkerData();
		}
	}, [
		selectedWorker,
		selectedService,
		selectedOptions,
		creator.isCreator,
		creatorWorkers,
	]);

	const getData = (selectedDate, service, serviceOption, worker) => {
		let data = [];
		if (service && selectedDate) {
			let filterDate = [];
			let selectedWeekday = new Date(selectedDate).getDay();

			const duration = serviceOption
				? serviceOption.duration
				: service.duration;

			if (worker) {
				let workingHours = worker?.workingHours
					.filter((workingHour) => {
						return workingHour.weekday === selectedWeekday;
					})
					.sort((a, b) => {
						return (
							new Date(
								new Date(
									new Date(selectedDate).setHours(a.from.split(":")[0])
								).setMinutes(a.from.split(":")[1])
							).getTime() -
							new Date(
								new Date(
									new Date(selectedDate).setHours(b.from.split(":")[0])
								).setMinutes(b.from.split(":")[1])
							).getTime()
						);
					});

				let serviceHours = service?.serviceHours
					.filter((serviceHour) => {
						return serviceHour.weekday === selectedWeekday;
					})
					.sort((a, b) => {
						return (
							new Date(
								new Date(
									new Date(selectedDate).setHours(a.from.split(":")[0])
								).setMinutes(a.from.split(":")[1])
							).getTime() -
							new Date(
								new Date(
									new Date(selectedDate).setHours(b.from.split(":")[0])
								).setMinutes(b.from.split(":")[1])
							).getTime()
						);
					});

				workingHours.forEach((workingHour) => {
					let start = new Date(
						new Date(
							new Date(selectedDate).setHours(workingHour.from.split(":")[0])
						).setMinutes(workingHour.from.split(":")[1])
					).getTime();
					let end = new Date(
						new Date(
							new Date(selectedDate).setHours(workingHour.to.split(":")[0])
						).setMinutes(workingHour.to.split(":")[1])
					).getTime();

					let hours = [];

					for (let h = start; h < end; h += duration * 60 * 1000) {
						const startTime = new Date(h).getTime();
						const endTime = startTime + duration * 60 * 1000;

						// Verificar si hay citas en conflicto

						const conflictingAppointment = worker.appointments?.find(
							(appointment) => {
								const startTimeAppointment = new Date(
									appointment.date
								).getTime();
								const endTimeAppointment =
									new Date(appointment.date).getTime() +
									(appointment?.serviceOption?.duration ??
										appointment?.service?.duration) *
										60000;

								// Comprobar si la cita en conflicto ocupa este intervalo
								return (
									(startTime >= startTimeAppointment &&
										startTime < endTimeAppointment) ||
									(startTime <= startTimeAppointment &&
										endTime > startTimeAppointment)
								);
							}
						);

						// Si hay una cita en conflicto, avanzar `h` al final de esa cita
						if (conflictingAppointment) {
							const endTimeAppointment =
								new Date(conflictingAppointment.date).getTime() +
								(conflictingAppointment?.serviceOption?.duration ??
									conflictingAppointment?.service?.duration) *
									60000;

							h = endTimeAppointment - duration * 60 * 1000; // Avanzar `h` para justo después de la cita
							continue; // Volver al inicio del loop para comprobar el nuevo hueco
						}

						// Verificar si no hay vacaciones del trabajador
						const foundHoliday = worker.workerHolidays
							.filter(
								(workerHoliday) =>
									new Date(workerHoliday.date).getDate() ===
										new Date(selectedDate).getDate() &&
									new Date(workerHoliday.date).getMonth() ===
										new Date(selectedDate).getMonth() &&
									new Date(workerHoliday.date).getFullYear() ===
										new Date(selectedDate).getFullYear()
							)
							.find(
								(workerHoliday) =>
									(startTime >=
										new Date(workerHoliday.date).setHours(
											parseInt(workerHoliday.from.split(":")[0]),
											parseInt(workerHoliday.from.split(":")[1])
										) &&
										startTime <
											new Date(workerHoliday.date).setHours(
												parseInt(workerHoliday.to.split(":")[0]),
												parseInt(workerHoliday.to.split(":")[1])
											)) ||
									(startTime <=
										new Date(workerHoliday.date).setHours(
											parseInt(workerHoliday.from.split(":")[0]),
											parseInt(workerHoliday.from.split(":")[1])
										) &&
										endTime >
											new Date(workerHoliday.date).setHours(
												parseInt(workerHoliday.from.split(":")[0]),
												parseInt(workerHoliday.from.split(":")[1])
											))
							);

						if (!foundHoliday) {
							// Verificar que no se solapen con los horarios del servicio
							if (
								new Date(
									new Date(
										new Date(selectedDate).setHours(
											workingHour.to.split(":")[0]
										)
									).setMinutes(workingHour.to.split(":")[1])
								).getTime() >=
								new Date(h).getTime() + duration * 60 * 1000
							) {
								if (
									serviceHours?.find((serviceHour) => {
										let startService = new Date(
											new Date(
												new Date(selectedDate).setHours(
													serviceHour.from.split(":")[0]
												)
											).setMinutes(serviceHour.from.split(":")[1])
										).getTime();
										let endService = new Date(
											new Date(
												new Date(selectedDate).setHours(
													serviceHour.to.split(":")[0]
												)
											).setMinutes(serviceHour.to.split(":")[1])
										).getTime();

										return startTime >= startService && endTime <= endService;
									})
								) {
									hours.push(
										("0" + new Date(h).getHours()).slice(-2) +
											":" +
											("0" + new Date(h).getMinutes()).slice(-2)
									);
									// En lugar de salir del loop, seguimos buscando más huecos disponibles
								}
							}
						}
					}

					let index = filterDate.findIndex(
						(date) => date.date === selectedDate
					);

					if (index > -1) {
						filterDate[index].hours = [...filterDate[index].hours, ...hours];
					} else {
						filterDate.push({
							date: selectedDate,
							hours,
						});
					}
				});
			}

			const today = new Date();
			if (
				filterDate.length > 0 &&
				selectedDate.getDate() === today.getDate() &&
				selectedDate.getMonth() === today.getMonth() &&
				selectedDate.getFullYear() === today.getFullYear()
			) {
				filterDate[0].hours = filterDate[0].hours.filter((hour) => {
					return (
						parseInt(hour.split(":")[0]) > today.getHours() ||
						(parseInt(hour.split(":")[1]) === today.getHours() &&
							parseInt() > today.getMinutes())
					);
				});
			}

			data =
				filterDate.length > 0
					? {
							[`${new Date(selectedDate).getFullYear()}-${(
								"0" +
								(new Date(selectedDate).getMonth() + 1)
							).slice(-2)}-${("0" + new Date(selectedDate).getDate()).slice(
								-2
							)}`]: filterDate[0].hours,
					  }
					: [];
		} else {
			data = [];
		}
		return data;
	};

	const handleDateTimeSelect = ({ date }) => {
		const data = getData(
			date,
			selectedService,
			selectedOptions,
			selectedWorker
		);
		setSelectedDateTime(date);
		setAvailableHours(data);
		setSelectedTime(null);
	};

	const handleTimeSelect = ({ time }) => {
		setSelectedTime(time);
	};

	const handleConfirm = () => {
		if (selectedWorker && selectedTime) {
			navigate(`/${basePath}/confirmation`, {
				state: {
					selectedService,
					selectedOptions,
					selectedWorker,
					selectedDate: `${new Date(selectedDateTime).getFullYear()}-${(
						"0" +
						(new Date(selectedDateTime).getMonth() + 1)
					).slice(-2)}-${("0" + new Date(selectedDateTime).getDate()).slice(
						-2
					)}`,
					selectedTime: selectedTime,
				},
			});
		}
	};

	const getFormattedPriceWithDiscount = (price, discount) => {
		if (discount && discount > 0) {
			const discountedPrice = price - (price * discount) / 100;
			return (
				<>
					{/* Precio original tachado */}
					<span
						style={{
							textDecoration: "line-through",
							color: "gray",
							marginRight: "8px",
						}}
					>
						{new Intl.NumberFormat(creator.language ?? "en", {
							style: "currency",
							currency: creator.currency ?? "eur",
						}).format(price)}
					</span>
					{/* Precio con descuento en rojo */}
					<span style={{ color: "red", fontWeight: "bold" }}>
						{new Intl.NumberFormat(creator.language ?? "en", {
							style: "currency",
							currency: creator.currency ?? "eur",
						}).format(discountedPrice)}
					</span>
				</>
			);
		}

		// Si no hay descuento, devuelve solo el precio normal
		return new Intl.NumberFormat(creator.language ?? "en", {
			style: "currency",
			currency: creator.currency ?? "eur",
		}).format(price);
	};
	const { user } = useContext(UserContext); // Usamos el contexto para obtener el usuario y getUser

	const navbarHeight = user ? 50 : 0; // altura de la navbar si existe

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: `calc(100vh - ${90 + navbarHeight}px)`, // ajusta dinámicamente
				backgroundColor: creator?.backgroundColor || "#ffffff",
				color: creator?.fontColor || "#000000",
				overflow: "hidden",
			}}
		>
			{/* Flecha atrás */}

			<Box
				sx={{
					flex: 1,
					padding: { xs: "0 16px 120px", sm: "0 30px 120px" },
					overflow: "visible", // ❗ aquí nada de scroll interno
				}}
			>
				<Box
					sx={{
						margin: "0 auto",
						display: { xs: "none", sm: "none", md: "none" }, // ❗ solo visible en escritorio
					}}
				>
					<Paper
						sx={{
							padding: "20px",
							border: !creator?.showShadows
								? "1px solid " + alpha(creator?.fontColor ?? "#000000", 0.2)
								: "none",
							boxShadow: creator?.showShadows
								? getLuminance(creator?.backgroundColor ?? "#FFFFFF") >= 0.5
									? "0px 2px 10px rgba(0, 0, 0, 0.05)"
									: "0px 2px 10px rgba(255, 255, 255, 0.35)"
								: "none",
							backgroundColor: creator?.backgroundColor ?? "#FFFFFF",
							color: creator?.fontColor ?? "#000000",
							marginBottom: "40px",
						}}
					>
						<Typography>
							{selectedOptions
								? `${selectedService.title} - ${selectedOptions.title}`
								: selectedService.title}
						</Typography>
						<Typography>
							{selectedOptions
								? getFormattedPriceWithDiscount(
										selectedOptions.price,
										selectedOptions.discount
								  )
								: getFormattedPriceWithDiscount(
										selectedService.price,
										selectedService.discount
								  )}
						</Typography>
					</Paper>
				</Box>
				<Box sx={{ maxWidth: "calc(100% - 0px)" }}>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							gap: 1,
							marginBottom: "8px",
						}}
					>
						<IconButton
							onClick={() => navigate(-1)}
							sx={{
								color: (getLuminance(creator?.backgroundColor ?? "#FFFFFF") >=
									0.5
									? darken
									: lighten)(creator?.fontColor ?? "#000000", 0.8),
								padding: "6px",
							}}
						>
							<IconArrowLeft size={22} />
						</IconButton>

						<Typography
							variant="h4"
							sx={{
								fontSize: "15px",
								fontWeight: 600,
							}}
						>
							{t("selectWorker")}
						</Typography>
					</Box>

					<FormControl fullWidth sx={{ marginBottom: "20px" }}>
						<Select
							displayEmpty
							value={selectedWorker?.id || ""}
							onChange={handleWorkerSelect}
							sx={{
								"& .MuiOutlinedInput-notchedOutline": {
									borderColor: creator?.fontColor ?? "#000000",
								},
								"&:hover .MuiOutlinedInput-notchedOutline": {
									borderColor: creator?.mainColor ?? "#43BD98",
								},
								"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
									borderColor: creator?.mainColor ?? "#43BD98",
								},
								"& .MuiList-root": {
									backgroundColor: creator?.backgroundColor ?? "#FFFFFF",
								},
								color: creator?.fontColor ?? "#000000",
							}}
						>
							<MenuItem value="" disabled>
								<Typography>{t("selectWorker")}</Typography>
							</MenuItem>

							{workersData &&
								workersData.map((worker) => (
									<MenuItem
										key={worker.id}
										value={worker.id}
										sx={{
											"&.Mui-selected": {
												backgroundColor: creator?.mainColor ?? "#43BD98",
												color: "#FFFFFF",
												"&:hover": {
													backgroundColor: creator?.mainColor ?? "#16a085",
												},
											},
										}}
									>
										{worker.name}
									</MenuItem>
								))}
						</Select>
					</FormControl>

					<Typography
						variant="h4"
						gutterBottom
						sx={{
							fontSize: "16px",
							fontWeight: 600,
							marginBottom: 2,
							marginTop: 2,
						}}
					>
						{t("selectDayAndTime")}
					</Typography>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							flex: 1,
							marginTop: "12px",
							opacity: selectedWorker ? 1 : 0.5,
							pointerEvents: selectedWorker ? "auto" : "none",
							transition: "opacity 0.3s ease",
							minHeight: 0, // 🔑 esto permite que el hijo calcule su altura y haga scroll
							overflow: "hidden", // evita doble scroll
						}}
					>
						<CustomCalendar
							onDateTimeSelect={handleDateTimeSelect}
							onTimeSelect={handleTimeSelect}
							availability={availableHours}
						/>
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					position: "fixed",
					width: "100%",
					bottom: 0,
					right: 0,
					padding: "20px",
					textAlign: "right",
					backgroundColor: creator?.backgroundColor || "#ffffff",
				}}
			>
				<Button
					variant="contained"
					color={selectedWorker && selectedTime ? "primary" : "default"}
					sx={{
						padding: "10px 20px",
						width: { xs: "calc(100% - 40px)", sm: "auto" },
						"&.Mui-disabled": {
							opacity: 0.5,
							color:
								getLuminance(creator?.mainColor ?? "#ffffff") >= 0.5
									? "#000000"
									: "#FFFFFF", // Texto de los botones primarios
							backgroundColor: creator?.mainColor ?? "#43BD98",
						},
					}}
					disabled={!selectedWorker || !selectedTime}
					onClick={handleConfirm}
				>
					{t("confirmAppointment")}
				</Button>
			</Box>
		</Box>
	);
}

export default Schedule;
